import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import { BusinessIcon } from './business';
import { UserIcon } from './users';

import { translate, DashboardMenuItem, MenuItemLink } from 'react-admin';

const items = [
  {
    name: 'businesses',
    to: 'businesses',
    text: 'Businesses',
    icon: <BusinessIcon />
  },
  {
    name: 'users',
    to: 'users',
    text: 'Users',
    icon: <UserIcon />
  }
];

const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%'
  }
};

const Menu = ({ onMenuTap, translate, logout }) => (
  <div style={styles.main}>
    <DashboardMenuItem onClick={onMenuTap} />
    {items.map(item => (
      <MenuItemLink
        key={item.name}
        to={`/${item.to}`}
        primaryText={item.text}
        leftIcon={item.icon}
        onClick={onMenuTap}
      />
    ))}
  </div>
);

const enhance = compose(
  connect(state => ({
    theme: state.theme,
    locale: state.locale
  })),
  translate
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/Menu.js